import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ROLE_ADMIN_ID, ROLE_TALENT_ID } from "../../configs/api";
import { authApi } from "../../services/auth.service";
import { OauthToken } from "../../types/oauth";
import { User } from "../../types/users";

export interface AuthState {
  user: User | null;
  token: OauthToken | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<OauthToken | null>) => {
      state.token = action.payload;
    },
    clearSession: (state) => {
      state.token = null;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          state.token = {
            accessToken: payload.access_token,
            refreshToken: payload.refresh_token,
            expiresIn: payload.expires_in,
          };
        }
      )
      .addMatcher(
        authApi.endpoints.getUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload;
        }
      )
      .addMatcher(
        authApi.endpoints.loadUser.matchFulfilled,
        (state, { payload }) => {
          if (payload.role_id == ROLE_ADMIN_ID) {
            state.user = payload;
          } else {
            console.error("Not a admin user! Aborted");
            state.user = null;
            state.token = null;
            //TODO: how to throw error from here?
          }
        }
      )
      .addMatcher(authApi.endpoints.logout.matchFulfilled, (state) => {
        state.token = null;
        state.user = null;
      });
  },
});

export const { setUser, setToken, clearSession } = authSlice.actions;

export const selectCurrentUser = (state: RootState) => state.auth.user;

export default authSlice.reducer;
